import React from 'react';
import { Modal } from 'react-bootstrap';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const MetricsConsideredModal = ({
  show,
  onHide,
  objective = "Improve staff wellbeing",
  date = "13th August 2025",
  metricsDateRangeData = [],
  isDataLoading
}) => {
  const tableData = metricsDateRangeData.map(item => ({
    metric: item.metricsName,
    riskLevel: item.riskLevel
  }));


  const getRiskLevelBadge = (riskLevel) => {
    const badgeClass = `metrics-risk-badge ${riskLevel === 'yellow' || riskLevel === 'amber' ? 'amber' : riskLevel}`;
    const badgeText = riskLevel === 'green' ? 'Green' : riskLevel === 'yellow' || riskLevel === 'amber' ? 'Amber' : 'Red';
    
    return (
      <div className={badgeClass}>
        {badgeText}
      </div>
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="metrics-considered-modal-title"
      centered
      className="metrics-modal"
    >
      <div className="metrics-modal-header">
        <div className="metrics-modal-header-content">
          <h5 className="metrics-modal-title">{objective}</h5>
          <div className="metrics-modal-date">
            <img src="/assets/icons/calendar.svg" alt="Calendar" className="w-h-16" />
            <span>{date}</span>
          </div>
        </div>
      </div>

      <Modal.Body className="metrics-modal-body">
        <div className="metrics-modal-table-wrapper">
          <table className="metrics-modal-table">
            <thead>
              <tr>
                <th className="metrics-header">Metrics</th>
                <th className="risk-header">Risk Level</th>
              </tr>
            </thead>
            <tbody>
              {isDataLoading ? (
                [...Array(5)].map((_, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                    <td className="metrics-cell">
                      <span className="text-axis fw-500 text-16">
                        <Skeleton
                          width={140}
                          height={16}
                          baseColor="#f3f3f3"
                          highlightColor="#ecebeb"
                        />
                      </span>
                    </td>
                    <td className="risk-cell">
                      <Skeleton
                        width={60}
                        height={20}
                        borderRadius={10}
                        baseColor="#f3f3f3"
                        highlightColor="#ecebeb"
                      />
                    </td> 
                  </tr>
                ))
              ) : (
              tableData.length > 0 ? (
                tableData.map((item, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                    <td className="metrics-cell">
                      <span className="text-axis fw-500 text-16">{item.metric}</span>
                    </td>
                    <td className="risk-cell">
                      {getRiskLevelBadge(item.riskLevel)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" className="text-center text-muted py-4">
                    No Records found
                  </td>
                </tr>
              )
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MetricsConsideredModal;
